import { ClaimFilterFormValue } from "./services/claims-filter-form-builder.service";
import { NewClaimForm } from "./services/new-claim-form-builder.service";
import { ClaimColumnName, Claim } from "@helper/types/claim";

export class Get {
	public static readonly type = "[Claims] Get";
	constructor(public filter: ClaimFilterFormValue) { }
}

export class Reset {
	public static readonly type = "[Claims] Reset";
}

export class Select {
	public static readonly type = "[Claims] Select";
	constructor(public claimIds: number[]) { }
}

export class Create {
	public static readonly type = "[Claims] Create";
	constructor(public claimForm: NewClaimForm[]) { }
}

export class SetColumns {
	public static readonly type = "[Claims] Set Columns";
	constructor(public columns: ClaimColumnName[]) { }
}

export class Upload {
	public static readonly type = "[Claims] Upload Claims";
	constructor(public claims: Partial<Claim>[]) { }
}

export class Delete {
	public static readonly type = "[Claims] Delete Claims";
	constructor(public claimsIds: number[]) { }
}

export class SetVisible {
	public static readonly type = "[Claims] Set Visible";
	constructor(public claimsIds: number[]) { }
}

export class SetFilter {
	public static readonly type = "[Claims] Set Filter";
	constructor(public filter: ClaimFilterFormValue) { }
}

export class UpdateClaims {
	public static readonly type = "[Claims] Update Claims";
}
